/* Horti Club cart helpers (2026-10-14/15):
   1. "Top up with one plant": fills [data-hortclub-topup] (rendered by
      hortclub-free-shipping-bar when the cart is below the minimum order) with
      the cheapest plant that is >= the remaining amount, in stock for the
      customer's city.
   2. Stock guard: blocks checkout when a cart line exceeds the selected city's
      stock, because Shopify would ship the rest from the other nursery as a
      second shipment and charge shipping twice. Data comes from
      snippets/hortclub-stock-lines.liquid. */
(function () {
  if (window.__hortclubTopupBound) return;
  window.__hortclubTopupBound = true;

  var CACHE_KEY = 'hortclub-topup-v1';
  var CACHE_MS = 10 * 60 * 1000;
  var catalog = null;
  var loading = null;
  var busy = false;
  var timer = null;
  var guardTimer = null;

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function city() {
    try { return window.localStorage.getItem('hortclub-location') || 'Faisalabad'; } catch (e) { return 'Faisalabad'; }
  }

  function maxInches(text) {
    var max = 0, re = /(\d+(?:\.\d+)?)\s*(?:"|''|″|”|inch)/gi, m;
    while ((m = re.exec(String(text || ''))) !== null) max = Math.max(max, parseFloat(m[1]));
    return max;
  }

  function fetchPage(n) {
    return fetch('/collections/nurseries?view=topup&page=' + n, { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (txt) { return JSON.parse(txt); });
  }

  function loadCatalog() {
    if (catalog) return Promise.resolve(catalog);
    try {
      var c = JSON.parse(window.sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && Date.now() - c.at < CACHE_MS && c.items) { catalog = c.items; return Promise.resolve(catalog); }
    } catch (e) {}
    if (loading) return loading;
    loading = fetchPage(1).then(function (first) {
      var reqs = [];
      for (var p = 2; p <= first.pages; p++) reqs.push(fetchPage(p));
      return Promise.all(reqs).then(function (rest) {
        var items = first.items.slice();
        rest.forEach(function (pg) { items = items.concat(pg.items); });
        catalog = items;
        try { window.sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), items: items })); } catch (e) {}
        return items;
      });
    }).catch(function () { loading = null; return []; });
    return loading;
  }

  function stockedForCity(it) {
    var c = city();
    if (c === 'Other Cities') return false;
    var q = c === 'Lahore' ? it.l : it.f;
    if (q === null || q === undefined) return true; // metafield not set: trust "available"
    return Number(q) > 0;
  }

  function pick(items, remaining, cart) {
    var inCartV = {}, inCartP = {};
    (cart.items || []).forEach(function (i) { inCartV[i.variant_id] = 1; inCartP[i.product_id] = 1; });
    var best = null;
    items.forEach(function (it) {
      if (it.pr < remaining) return;
      if (inCartP[it.p] || inCartV[it.v]) return;
      if (maxInches(it.vt) >= 18) return; // avoid oversized delivery triggers
      if (!stockedForCity(it)) return;
      if (!best || it.pr < best.pr) best = it;
    });
    return best;
  }

  function money(paisa) {
    return 'Rs.' + Math.round(paisa / 100).toLocaleString('en-US');
  }

  function render(el, it) {
    var title = it.t + (it.vt && it.vt !== 'Default Title' ? ' – ' + it.vt : '');
    el.innerHTML =
      '<div class="hortclub-topup__card">' +
      (it.img ? '<img class="hortclub-topup__img" src="' + esc(it.img) + '" alt="" width="56" height="56" loading="lazy">' : '') +
      '<div class="hortclub-topup__body"><div class="hortclub-topup__lead">Reach the minimum with one plant</div>' +
      '<a class="hortclub-topup__title" href="' + esc(it.h) + '">' + esc(title) + '</a>' +
      '<div class="hortclub-topup__price">' + money(it.pr) + '</div></div>' +
      '<button type="button" class="button button--secondary hortclub-topup__add" data-hortclub-direct-add data-variant-id="' + esc(it.v) + '" data-product-url="' + esc(it.h) + '">Add</button></div>';
    el.setAttribute('data-filled', 'true');
  }

  function fill() {
    timer = null;
    if (busy) return;
    if (!document.querySelector('[data-hortclub-topup]:not([data-filled])')) return;
    busy = true;
    Promise.all([loadCatalog(), fetch('/cart.js').then(function (r) { return r.json(); })]).then(function (res) {
      var items = res[0], cart = res[1];
      document.querySelectorAll('[data-hortclub-topup]:not([data-filled])').forEach(function (el) {
        var min = parseInt(el.getAttribute('data-min-paisa'), 10) || 200000;
        var remaining = Math.max(0, min - cart.items_subtotal_price);
        if (!remaining) { el.setAttribute('data-filled', 'none'); return; }
        var best = pick(items, remaining, cart);
        if (best) render(el, best); else el.setAttribute('data-filled', 'none');
      });
    }).catch(function () {}).then(function () { busy = false; });
  }

  // ---- Stock guard -------------------------------------------------------
  function guard() {
    guardTimer = null;
    var c = city();
    var key = c === 'Lahore' ? 'l' : (c === 'Other Cities' ? null : 'f');
    var cityLabel = c === 'Lahore' ? 'Lahore' : 'Faisalabad';

    document.querySelectorAll('[data-hortclub-stock-warning]').forEach(function (w) {
      var js = w.previousElementSibling;
      if (!js || !js.hasAttribute('data-hortclub-stock-lines')) return;
      var lines;
      try { lines = JSON.parse(js.textContent); } catch (e) { return; }

      var bad = [];
      if (key) {
        var agg = {};
        lines.forEach(function (ln) {
          var a = agg[ln.v] || (agg[ln.v] = { t: ln.t, vt: ln.vt, q: 0, f: ln.f, l: ln.l });
          a.q += ln.q;
        });
        Object.keys(agg).forEach(function (k) {
          var a = agg[k];
          if ((a.f === null || a.f === undefined) && (a.l === null || a.l === undefined)) return; // never synced: skip
          var have = a[key];
          have = (have === null || have === undefined) ? 0 : Math.max(0, Number(have));
          if (a.q > have) bad.push({ name: a.t + (a.vt && a.vt !== 'Default Title' ? ' (' + a.vt + ')' : ''), have: have, want: a.q });
        });
      }

      var msg = '';
      if (bad.length) {
        msg = 'Not enough stock in ' + cityLabel + ' for: ' + bad.slice(0, 3).map(function (b) {
          return b.name + ' (' + (b.have > 0 ? 'only ' + b.have + ' available, you have ' + b.want : 'not available') + ')';
        }).join('; ') + (bad.length > 3 ? '; and ' + (bad.length - 3) + ' more' : '') +
          '. Please reduce the quantity or remove it to continue. Each order ships from one nursery.';
      }
      if (w.textContent !== msg) w.textContent = msg;
      if (msg) w.setAttribute('data-has-issue', 'true'); else w.removeAttribute('data-has-issue');
    });

    var any = !!document.querySelector('[data-hortclub-stock-warning][data-has-issue]');
    document.querySelectorAll('#CartDrawer-Checkout, #checkout').forEach(function (b) {
      if (any) {
        b.disabled = true;
        b.setAttribute('data-hortclub-stock-blocked', 'true');
      } else if (b.hasAttribute('data-hortclub-stock-blocked')) {
        b.removeAttribute('data-hortclub-stock-blocked');
        if (!b.hasAttribute('data-hortclub-min-blocked')) b.disabled = false;
      }
    });
  }

  // Do NOT reset the timers on every call: the page mutates constantly and a
  // resetting debounce would never fire.
  function schedule() { if (!timer) timer = setTimeout(fill, 150); }
  function scheduleGuard() { if (!guardTimer) guardTimer = setTimeout(guard, 100); }

  new MutationObserver(function () {
    if (document.querySelector('[data-hortclub-topup]:not([data-filled])')) schedule();
    if (document.querySelector('[data-hortclub-stock-warning]')) scheduleGuard();
  }).observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('hortclub:location-changed', function () {
    document.querySelectorAll('[data-hortclub-topup]').forEach(function (e) { e.removeAttribute('data-filled'); e.innerHTML = ''; });
    schedule();
    scheduleGuard();
  });
  document.addEventListener('DOMContentLoaded', function () { schedule(); scheduleGuard(); });
  schedule();
  scheduleGuard();
})();
